import Vue from "vue";
import VueSlideout from "./vueSlideout.vue";
import { VueSlideoutEvent } from "./vueSlideoutEvent";
import { bus } from "./bus";

let slideoutCount = 0;
let vueSlideoutGroup: HTMLElement & {
  style: {
    display: string;
  };
};

const decrement = function() {
  if (slideoutCount > 0) {
    slideoutCount--;
    if (slideoutCount < 1) {
      vueSlideoutGroup.style.display = "";
    }
  }
  return slideoutCount;
};

const slideout = {
  hideSlideoutGroup() {
    slideoutCount = 0;
    vueSlideoutGroup.style.display = "";
  },
  mountRoot(appendTo = "body") {
    const element = document.querySelector(appendTo);
    if (element) {
      element.appendChild(vueSlideoutGroup);
    }
  },
  get count() {
    return slideoutCount;
  },
  clear() {
    if (slideoutCount > 0) {
      decrement();
      while (vueSlideoutGroup.firstChild) {
        vueSlideoutGroup.removeChild(vueSlideoutGroup.firstChild);
      }
    }
  },
  mount(vm: Vue) {
    // Hack to ensure the element doesn't get appended in-place in the component-tree, but is added at the root of the document.
    vueSlideoutGroup.appendChild(vm.$el);
    const mountedEvent = new VueSlideoutEvent("mounted-" + vm.$id, vm.$id, vm, null);

    slideout.$emit(mountedEvent);
  },
  increment() {
    slideoutCount++;
    if (slideoutCount >= 1) {
      vueSlideoutGroup.style.display = "flex";
    }
    return slideoutCount;
  },
  parent(vm: Vue) {
    let parent = vm.$el.previousSibling;
    while (parent && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.previousSibling;
    }
    return parent;
  },
  remove(vm: Vue) {
    Vue.nextTick(() => {
      decrement();
      if (vm.$el.parentNode) {
        vm.$el.parentNode.removeChild(vm.$el);
      }
    });
  },
  $emit(event: VueSlideoutEvent) {
    bus.$emit(event.type, event);

    // if (event.type.startsWith("hidden-")) {
    //   Vue.nextTick(() => {
    //     slideout.remove(event.detail.vm);
    //     // decrement();
    //   });
    // }
  },
  $on(eventName: string | string[], callback: Function) {
    bus.$on(eventName, callback);
  },
  $off(eventName: string | string[], callback: Function) {
    bus.$off(eventName, callback);
  },
};

Object.defineProperty(slideout, "length", {
  get() {
    return slideoutCount;
  },
});

const Plugin = {
  install(vue: typeof Vue) {
    vue.component("VueSlideout", VueSlideout);
    if (!vueSlideoutGroup) {
      vueSlideoutGroup = document.createElement("div");
      vueSlideoutGroup.id = "vueSlideoutGroup";
      vueSlideoutGroup.classList.add("vue-slideout-group");
    }

    document.addEventListener("keyup", event => {
      if (event.key === "Escape") {
        const slideouts = document.getElementsByClassName("vue-slideout");
        const topSlideout = slideouts && slideouts.length > 0 && slideouts[slideouts.length - 1];
        if (topSlideout) {
          const escapeEvent = new VueSlideoutEvent("escape-" + topSlideout.id, topSlideout.id, (this as unknown) as Vue, event);
          slideout.$emit(escapeEvent);

          const hideEvent = new VueSlideoutEvent("hide-" + topSlideout.id, topSlideout.id, (this as unknown) as Vue, event);
          slideout.$emit(hideEvent);
        }
      }
    });

    vue.prototype.$vueSlideout = slideout;
  },
};

export { Plugin, VueSlideout, bus as eventBus, VueSlideoutEvent, slideout };
